import {
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import type { AnyAction, Store, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import tenantReducer from "../components/Tenant/TenantSlice";
import mixReducer from "../components/Mix/MixSlice";
import condimentReducer from "../components/Condiment/CondimentSlice";
import categoriesReducer from "../components/Categories/slice/CategoriesSlice";
import mixDetailsReducer from "../components/MixDetails/MixDetailsSlice";
import condimentDetailsReducer from "../components/CondimentDetails/CondimentDetailsSlice";
import modalReducer from "../components/Modal/slice/ModalSlice";
import mixtureReducer from "../components/Mixture/MixtureSlice";
import languageReducer from "../components/Language/slice/LanguageSlice";
import asideReducer from "../components/Aside/slice/AsideSlice";
import checkoutReducer from "../components/Checkout/slice/CheckoutSlice";
import breadcrumbsReducer from "../components/Breadcrumbs/slice/BreadcrumbsSlice";
import calculationReducer from "../components/Calculation/slice/CalculationSlice";
import MixByFuchsReducer from "../components/MixByFuchs/MixByFuchs";

const rootReducer = combineReducers({
  tenant: tenantReducer,
  mix: mixReducer,
  condiment: condimentReducer,
  category: categoriesReducer,
  mixDetails: mixDetailsReducer,
  condimentDetails: condimentDetailsReducer,
  modal: modalReducer,
  mixture: mixtureReducer,
  language: languageReducer,
  aside: asideReducer,
  checkout: checkoutReducer,
  breadcrumbs: breadcrumbsReducer,
  calculation: calculationReducer,
  mixByFuchs: MixByFuchsReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore["dispatch"];
export type AppThunkDispatch = ThunkDispatch<RootState, any, AnyAction>;
export type AppStore = Omit<Store<RootState, AnyAction>, "dispatch"> & {
  dispatch: AppThunkDispatch;
};

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppThunkDispatch>();
